import React, {Component} from 'react';
import PanelWrapper from "./PanelWrapper";
import ListDesignerHoc from "../../../../HocHelpers/ListDesignerHoc";

class ExpansionPanels extends Component {

    constructor(props) {
        super(props);
        this.state = {
            panels: [
                {label: 'General Information', name: 'general', hidden: false},
                {label: 'Data Source', name: 'dataSource', hidden: false},
                {label: "Columns", name: 'columns', hidden: false, action: "openColumnModal"},
                // {label: "Sample Data", name: 'sampleData', hidden: false},
                {label: 'Chart', name: 'chart', hidden: false},
                {label: "Grid", name: 'grid', hidden: false},
                {label: "Developer Settings", name: 'devSettings', hidden: false}
            ],
        };
    }

    componentDidMount() {
        this.hidePanels();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data.presentation !== this.props.data.presentation) {
            this.hidePanels();
        }
    }

    hidePanels = () => {
        const {data} = this.props;
        const {panels} = this.state;
        if (data.presentation === 'grid' || data.presentation === undefined) {
            //chart hidden true
            panels[3].hidden = true;
            panels[4].hidden = false;
            this.setState({panels})
        } else if (data.presentation === 'chart') {
            //grid hidden true
            panels[3].hidden = false;
            panels[4].hidden = true;
            this.setState({panels})

        }
    };


    render() {
        const {panels} = this.state;
        return (
            panels.map((panel, index) => {
                return (
                    !panel.hidden && (
                        <PanelWrapper key={index}
                                      panel={panel}/>
                    )
                )
            })
        );
    }
}

export default ListDesignerHoc(ExpansionPanels);